import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBnVxwgTe7scng9N-X7iylBZFq1G8YxMAI',
  authDomain: 'thedojosite-d98de.firebaseapp.com',
  projectId: 'thedojosite-d98de',
  storageBucket: 'thedojosite-d98de.appspot.com',
  messagingSenderId: '771375559096',
  appId: '1:771375559096:web:22346edeb43876433bdf4d',
};

firebase.initializeApp(firebaseConfig);

const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();
const projectStorage = firebase.storage();

const timestamp = firebase.firestore.Timestamp;

export { projectFirestore, projectAuth, projectStorage, timestamp };
